import React from 'react';

import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary';

import classes from './PageContainer.module.scss';

interface Props {
    children: React.ReactNode;
    className?: string;
}

const PageContainer = ({ children, className }: Props) => {
    return (
        <div className={`${classes.PageContainerCss} ${className ?? ''}`}>
            <ErrorBoundary pageLevel={true}>{children}</ErrorBoundary>
        </div>
    );
};

export default PageContainer;
